<template>
  <div
    class="modal fade"
    id="loanCancelModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            ref="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4
            class="modal-title"
            id="myModalLabel"
          >
            {{ $t('string.cancelLoan') }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div class="form-horizontal">
              <div
                class="form-group"
                :class="{'has-error' : descriptionRequired}"
              >
                <label class="required">{{ $t('string.reason') }}</label>
                <textarea
                  class="form-control"
                  v-model="description"
                  :placeholder="$t('string.enterYourReason')"
                  rows="4"
                />
                <template v-if="descriptionRequired">
                  <span class="label-error">The description field is required</span>
                </template>
              </div>
            </div>
          </div>
          <div class="clearfix" />
        </div>
        <div class="modal-footer">
          <button
            :disabled="isLoading"
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
          <button-async-loading
            @click="onSave"
            :title="$t('button.save')"
            :is-loading="isLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonAsyncLoading from '@/views/borrows/_components/ButtonAsyncLoading'
import { mapGetters } from 'vuex'

export default {
  name: 'LoanCancelModal',
  components: { ButtonAsyncLoading },
  data () {
    return {
      descriptionRequired: false,
      isLoading: false,
      description: null
    }
  },
  computed: {
    ...mapGetters({
      loanSelected: 'applicantCancel/getLoanSelected',
      reloadLoanTable: 'applicantCancel/getReloadLoanTable'
    })
  },
  methods: {
    async onSave (e) {
      this.descriptionRequired = false
      if (!this.description) {
        this.isLoading = false
        this.descriptionRequired = true
        return 0
      }

      this.isLoading = true
      this.$store.commit('applicantCancel/SET_RELOAD_OTABLE', false)
      await this.$axios.post(process.env.VUE_APP_API + '/api/v1/status-cancel/cancel-loan', {
        loan_id: this.loanSelected,
        description: this.description
      }).then((response) => {
        if (response.data && response.data.data) {
          this.isLoading = false
          this.description = ''
          this.descriptionRequired = false
          this.$store.commit('applicantCancel/SET_LOAN_SELECTED', null)
          this.$store.commit('applicantCancel/SET_RELOAD_LOAN_TABLE', true)
          this.$refs.close.click()
        }
      }).catch((error) => {
        this.onResponseError(error)
      })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>

</style>
